<div
  *ngIf="!(userDetails$ | async).administrative"
  (clickOutside)="handleClickOutside($event)"
  [exclude]="'.click-to-call'"
  [excludeBeforeClick]="true"
>
  <button *ngIf="!isBlockIncomingCallsState" mat-button mat-raised-button color="primary-full" (click)="openWidget()">
    <i class="material-icons">call</i>
    <span class="m-l-sm" translate>MENU.MAKE_A_CALL</span>
  </button>
  <button *ngIf="isBlockIncomingCallsState" mat-button mat-raised-button color="warn-full" (click)="openWidget()">
    <i class="dnd-web-widget-icon"></i>
    <span class="m-l-sm" translate>MENU.MAKE_A_CALL</span>
  </button>
  <div [hidden]="!isOpened" class="widget-container">
    <iframe
      #iframe
      [src]="didUserInteractedWithPage ? webWidgetUrl : null"
      (load)="handleIframeLoaded()"
      width="280"
      height="530"
      frameborder="0"
      allow="geolocation;autoplay;microphone;camera;midi;encrypted-media;"
    ></iframe>
  </div>
</div>
